import { render, staticRenderFns } from "./DashboardShareItem.vue?vue&type=template&id=649f1488&scoped=true"
import script from "./DashboardShareItem.vue?vue&type=script&lang=js"
export * from "./DashboardShareItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f1488",
  null
  
)

export default component.exports